import { render, staticRenderFns } from "./layoutSidebar.vue?vue&type=template&id=090c52c4"
import script from "./layoutSidebar.vue?vue&type=script&lang=js"
export * from "./layoutSidebar.vue?vue&type=script&lang=js"
import style0 from "./layoutSidebar.vue?vue&type=style&index=0&id=090c52c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports